export const messages = {
  en: {
    getSalesInfo: {
      title: 'Sales Details',
      queryConditions: 'Query Conditions',
      orderId: 'Order ID',
      type: 'Type',
      name: 'Name',
      salesQuantity: 'Sales Quantity',
      userName: 'User Name',
      detailAmount: 'Detail Amount',
      productDiscount: 'Product Discount',
      orderDiscount: 'Order Discount',
      orderAmount: 'Order Amount',
      returnQuantity: 'Return Quantity',
      returnDetailAmount: 'Return Detail Amount',
      returnOrderAmount: 'Return Order Amount',
      createTime: 'Create Time',
      search: 'Search',
      reset: 'Reset',
      startTime: 'Start Time',
      endTime: 'End Time',
      productName: 'Product Name'
    }
  },
  zh: {
    getSalesInfo: {
      title: '销售明细',
      queryConditions: '查询条件',
      orderId: '订单号',
      type: '类型',
      name: '名称',
      salesQuantity: '销售数量',
      userName: '用户名称',
      detailAmount: '明细金额',
      productDiscount: '商品优惠',
      orderDiscount: '订单优惠',
      orderAmount: '订单金额',
      returnQuantity: '退货数量',
      returnDetailAmount: '退货明细金额',
      returnOrderAmount: '退货订单金额',
      createTime: '创建时间',
      search: '查询',
      reset: '重置',
      startTime: '开始时间',
      endTime: '结束时间',
      productName: '商品名称'
    }
  }
}